<template>
<div class="absolute right-0 top-12 cursor-pointer">
     <div class="opacity-90 bg-white rounded-full">
        <div v-if="isLogin" class="flex items-center pr-18px" @click="toggleDropdown()">
            <div class="p-2">
                <img class="icon-profile" v-if="profileImageUrl != null" :src="profileImageUrl">
                <img class="icon-profile" v-else src="../../../../assets/icon/profile-icon.png">
            </div>
            <div>
                <div class="text-22 text-tc-blue-1">{{profile.firstName}} {{profile.lastName}}</div>
                <div class="flex items-center">
                    <div class="text-22 text-tc-gray-3 mr-1">{{lbl.topbar.coin}}</div>
                    <div class="text-24 text-tc-blue-1 font-bold">{{FilterNumberFormat(userPoint)}}</div>
                    <div class="ml-1"><img class="w-14px" src="../../../../assets/icon/icon-tipcoin.png"></div>
                </div>
            </div>
            <div class="ml-4">
                <img src="@/assets/icon/icon-drop-down.png">
            </div>
        </div>
        <div v-else class="flex items-center pr-18px" @click="clickLogin()">
            <div class="p-2">
                <img class="icon-profile" src="../../../../assets/icon/profile-icon.png">
            </div>
            <div class="text-tc-blue-1 text-22">{{lbl.home.login.register_login}}</div>
        </div>
    </div>
    <div v-if="isLogin" v-show="showList && menuProfileList.length > 0">
        <MenuProfileDropdown
            ref="menu-dropdrow-profile"
            :itemList="menuProfileList"
            @select:drowdown="selectMenuProfile($event)"/>
    </div>
</div>

</template>
<script>
import Account from '@/helper/AccountHelper.js';
import { DropdownListValue } from "@/helper/FormHelper.js";
// import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
import AuthStatusMixin from "@/mixin/AuthStatusMixin";
import LocaleMixin from "@/mixin/LocaleMixin";
import MenuProfileDropdown from '@/components/Layout/TopBar/component/MenuPrfileDropdown/MenuProfileDropdown.vue';
import CacheHelper from '@/helper/CacheHelper'

//components
export default {
    name: 'ProfileLogin',
    mixins: [AuthStatusMixin,LocaleMixin],
    props: {
        modalController: Object,
    },
    components:{
        MenuProfileDropdown
    },
    data: function() {
        return {
            profileImageUrl: null,
            menuProfileList: [],
            showList: false,
        };
    },
    methods: {
        setItemList: function(){
            const menuDropdownList = new DropdownListValue();
            menuDropdownList.add(this.lbl.commonLbl.profile, 'profile');
            menuDropdownList.add(this.lbl.commonLbl.logout, 'logout');
            this.menuProfileList = menuDropdownList.list;
        },
        // AuthStatusMixin
        onAccountInit: function() {
            this.setItemList();
            if (this.isLogin) {
                let token = Account.getToken();
                let currentTime = new Date().getTime();
                let cacheUser = Account.getCacheUser();
                if(cacheUser.channel == 'line' && cacheUser.line){
                    this.profileImageUrl = cacheUser.line.pictureUrl + `?time=${currentTime}`
                }else{
                    if(this.profile){
                        this.profileImageUrl = ConfigManager.getApiUrl() +
                    `/profile/${this.profile.userId}/picture?type=large&token=${token}&time=${currentTime}`;
                    }
                }
            }
        },
        clickLogin: function() {
            this.modalController.loginModal.show();
        },
        selectMenuProfile: function(data){
            if(data.value === 'profile'){
                window.location.replace('/profile');
            }
            else if (data.value === 'logout') {
                this.confirmLogout();
                // this.onClickLogout();
            }else{
                this.toggleDropdown();
            }
        },
        confirmLogout: function () {
            this.modalController.confirmModal
                .clearModal()
                .setTitle(this.lbl.home.title_logout)
                .setMsg(this.lbl.home.confirm_logout)
                .setBtnOk(this.lbl.home.login.confirm)
                .show();
            this.modalController.confirmModal.onClickOk(() => {
                console.log('confirm logout');
                this.onClickLogout();
            });
        },
        onClickLogout: async function(){
            this.modalController.loadingModal.show();
            await Account.setLogout();
            let cache = new CacheHelper('local');
            cache.removeCache('register_channel');
            this.modalController.loadingModal.hide();
            window.location.replace('/home')
        },
        toggleDropdown: function(){
            this.showList = this.showList ? false : true
            if(this.showList){
                this.$refs['menu-dropdrow-profile'].openDropdown()
            }else{
                this.$refs['menu-dropdrow-profile'].closeDropdown()
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .icon-profile {
        height: 40px;
        border-radius: 50%;
    }
</style>
